import React, { useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import CustomButton from 'Components/CustomButton/CustomButton'
import ComboBox from 'Components/ComboBox'
import { Input } from 'Components/Input'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import { currentDate } from 'utils/helpers'

export default function CreateDocument({ setDocId, setSubmit }) {
  const [open, setOpen] = useState(false)
  const [types, setTypes] = useState([])
  const [file, setFile] = useState(null)

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      Type: '',
      Nom: '',
      Description: '',
      Externe: '',
      Datedéchéance: currentDate(),
    },
  })

  const fetchDocumentsTypes = async () => {
    const url = urls.fetchDocumentsTypes + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.Type}`, id: v.id, domain: v.Domains })
      })
      setTypes(filterTypes.filter((e) => e.domain === 'Professionnel'))
    }
  }

  const handleClickOpen = () => {
    setOpen(true)
    fetchDocumentsTypes()
    setSubmit(false)
  }

  const handleClose = () => {
    setOpen(false)
    setFile(null)
  }

  const onSubmitDoc = async (data) => {
    const formData = new FormData()
    if (file != null) formData.append('Lien', file)
    formData.append('Type', data.Type.id)
    formData.append('Nom', data.Nom)
    formData.append('Description', data.Description)
    formData.append('Externe', data.Externe)
    formData.append('Datedéchéance', data.Datedéchéance)

    const response = await makePostRequest(
      urls.crudDocumentsDetailsOperations,

      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    )
    if (response.status === 201) {
      let result = response.data
      setDocId(result)
      handleClose()
    }
  }

  return (
    <>
      <CustomButton sx={{ color: '#1976d2', fontSize: '16px' }} onClick={handleClickOpen}>
        {'>'}-Ajouter document
      </CustomButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'Black !important' }}>Ajouter Document</DialogTitle>
        <form onSubmit={handleSubmit(onSubmitDoc)} encType="multipart/form-data">
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => setValue('Type', j)}
              label="Type de document "
              data={types}
              name="Type"
              required={true}
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: true }}
              name="Nom"
              label="Nom"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: false,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: false }}
              name="Description"
              label="Description"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: false,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: false }}
              name="Externe"
              label="N° Externe"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: false,
                size: 'small',
              }}
              rules={{ required: false }}
              name="Datedéchéance"
              label="Datedéchéance"
            />
            <Button
              variant="contained"
              component="label"
              sx={{
                color: 'black',
                background: 'none',
                '&:hover': {
                  backgroundColor: '#aeaeae',
                },
              }}
            >
              <input
                name="file"
                type="file"
                filename={file}
                required={true}
                // accept="application/pdf"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </Button>
          </DialogContent>
          <DialogActions>
            <Button type="submit">Mettre à jour</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
